import React from 'react';

const Loadable = React.lazy(() => import('../../../pages/StatsFeature/Blog/Blog'));

export default Loadable;
